<form [formGroup]="cash4BikeFormGroup" (ngSubmit)="onSubmit();">

    <h3 class="mb-5 mt-5 col-md-6 underlineTitle ">Cash voor lease fiets
        <i placement="top"
                      ngbTooltip="Pas hier parameters aan voor de module Cash voor lease fiets"
                      class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
    </h3>

    <div class="form-row mb-3 h-100">


        <div class="col-md-5  col-sm-12">

            <div class="form-group">
                <div *ngIf="cash4BikeFormGroup.controls.tekstJaarlijkseLeaseKost.errors" class="text-danger md-1">
                    {{err[0]}}
                </div>
                <label class="font-weight-bold " for="textArea">Info jaarlijkse lease kost:</label>
                <i placement="top"
                ngbTooltip="Extra uitleg over het berekenen van de jaarlijkse lease kosten"
                class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                <textarea [(ngModel)]="cash4Bike.tekstJaarlijkseLeaseKost" formControlName="tekstJaarlijkseLeaseKost"
                    name="tekstJaarlijkseLeaseKost" id="tekstJaarlijkseLeaseKost" class="form-control"
                    rows="1"></textarea>
            </div>
            <div class="form-group">
                <div *ngIf="cash4BikeFormGroup.controls.tekstBrutoPerJaar.errors" class="text-danger md-1">
                    {{err[0]}}
                </div>
                <label class="font-weight-bold " for="textArea">Info bruto per jaar:</label>
                <i placement="top"
                ngbTooltip="Extra uitleg over het berekenen van de jaarlijkse bruto kosten."
                class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                <textarea [(ngModel)]="cash4Bike.tekstBrutoPerJaar" formControlName="tekstBrutoPerJaar"
                    name="tekstBrutoPerJaar" id="tekstBrutoPerJaar" class="form-control" rows="1"></textarea>
            </div>
            <div *ngIf="cash4BikeFormGroup.controls.tekstDetailsPatronaleRSZ.errors" class="text-danger md-1">
                {{err[0]}}
            </div>
            <label class="font-weight-bold " for="textArea">Info berekening patronale RSZ:</label>
            <i placement="top"
            ngbTooltip="Extra uitleg over het berekenen van de patronale RSZ."
            class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
            <textarea [(ngModel)]="cash4Bike.tekstDetailsPatronaleRSZ" formControlName="tekstDetailsPatronaleRSZ"
                name="tekstDetailsPatronaleRSZ" id="tekstDetailsPatronaleRSZ" class="form-control" rows="1"></textarea>
        </div>
        <div class="col-md-5 col-sm-12 mx-auto">



            <div class="form-group">
                <div *ngIf="cash4BikeFormGroup.controls.infoPatronaleRSZ.errors" class="text-danger md-1">
                    {{err[0]}}
                </div>
                <label class="font-weight-bold " for="textArea">Info Percentage patronale RSZ:</label>
                <i placement="top"
                ngbTooltip="Licht de gebruiker in over de verschillende percentages RSZ."
                class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                <textarea [(ngModel)]="cash4Bike.infoPatronaleRSZ" formControlName="infoPatronaleRSZ"
                    name="infoPatronaleRSZ" id="infoPatronaleRSZ" class="form-control" rows="1"></textarea>
            </div>
            <div class="form-group">
                <div *ngIf="cash4BikeFormGroup.controls.tekstWaarschuwing.errors" class="text-danger md-1">
                    {{err[0]}}
                </div>
                <label class="font-weight-bold " for="textArea">Waarschuwingsbericht:</label>
                <i placement="top"
                ngbTooltip="Extra waarschuwing die onderaan de module wordt weergegeven."
                class="fa fa-question-circle ml-1" style="font-size: 15px;" aria-hidden="true"></i>
                <textarea [(ngModel)]="cash4Bike.tekstWaarschuwing" formControlName="tekstWaarschuwing"
                    name="tekstWaarschuwing" class="form-control" rows="3"></textarea>
            </div>
    
    
        </div>
    </div>

    
    <div class="card-bottom col-12 mobile" [ngStyle]="{'background-color': onderneming.kleur}"></div>
    <div class="form-row">
        <div class="col-md-6   col-sm-12 "></div>
        <div class="col-md-6   col-sm-12 ">
            <button [disabled]="!cash4BikeFormGroup.valid" class="btn btn-dark btn-lg float-right mt-2"
                type="submit">OPSLAAN</button>
        </div>

    </div>


</form>